import hover from './hover';
import widgetInfo from './widget-info';

const root = {
	hover,
	widgetInfo
};

export default root;
